import {AvailabilityStateSlice} from '../slices/AvailabilityStateSlice';

export const authSessionRemovedExtra = (state: AvailabilityStateSlice): void => {
  state.restartPollingTimestamp = undefined;
  state.isEnabled = false;
  state.highDemandFlag = undefined;
};
